
const contents = "query NotificationUnseenCountClients {\n  viewer {\n    ...NotificationUnseenCountsField\n  }\n}\n\nfragment NotificationUnseenCountsField on Viewer {\n  notifications {\n    viewerUnseenCount\n  }\n}\n";
const sha256Hash = "ba96eeef772efcf1e0a52f148fdca86e0cdd28be9d85a076ba80776b0fa66a68";
export default { contents: contents, sha256Hash: sha256Hash };
